import { useProjectedChart, useTheme } from "@hooks";

export const TimePassed = () => {
  const { invertedTheme } = useProjectedChart();
  const { theme } = useTheme();

  const chartTheme = theme.chart.projection;

  const fill = invertedTheme ? chartTheme.inverted.footer : chartTheme.default.footer;

  return (
    <div style={{ userSelect: "none" }}>
      <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.5" cy="2.68201" r="2" fill={fill} fillOpacity="0.16" />
      </svg>{" "}
      <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.5" cy="2.68201" r="2" fill={fill} fillOpacity="0.16" />
      </svg>{" "}
      <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.5" cy="2.68201" r="2" fill={fill} fillOpacity="0.16" />
      </svg>
    </div>
  );
};
